import type { TFunction } from "i18next";
import { ApiFailure } from "./api.ts";

/** Words for an API error, falling back to the API's own message. */
export function errorText(t: TFunction, error: unknown): string {
  if (error instanceof ApiFailure) {
    const key = `errors.${error.code}`;
    const translated = t(key);
    // Specific messages from the API (team names, limits, which files) are more useful than the generic text.
    if (error.code === "invalid_input" || error.code === "forbidden" || error.code === "already_member" || error.code === "unsupported_file" || error.code === "too_large") {
      return error.message || translated;
    }
    if (translated !== key) return translated;
    // Unknown codes (a proxy error, another program answering): never show raw server text.
    return t("common.error");
  }
  return t("common.error");
}
